const SetupUsersCustomerNotSelectedActionTypes = {
  GET_CUSTOMER_NOT_SELECTED_START: 'GET_CUSTOMER_NOT_SELECTED_START',
  GET_CUSTOMER_NOT_SELECTED_SUCCESS: 'GET_CUSTOMER_NOT_SELECTED_SUCCESS',
  GET_CUSTOMER_NOT_SELECTED_FAILURE: 'GET_CUSTOMER_NOT_SELECTED_FAILURE',
  UPDATE_CUSTOMER_NOT_SELECTED: 'UPDATE_CUSTOMER_NOT_SELECTED',
};

export default SetupUsersCustomerNotSelectedActionTypes;
